export class SaleExportData {

    // Sale info
    public logo = "logo.img";
    public companyName;
    public companyRFC;
    public companyAddress;
    public companyPostalCode;
    public companyCity;
    public companyState;
    public companyCountry;
    public companyPhone;
    public companyEmail;
    public customerCurrency;
    public saleNumber;
    public customerName;
    public customerAddress;
    public contactName;
    public saleDate: Date;
    public saleType;
    public saleTypeId;
    public placeOfDelivery;
    public deliveryCommitmentDate: Date;
    public subtotal;
    public IVA;
    public amountDiscount: number;
    public total;
    public sellerName;
    public comments;
    public tipoVenta;
    public note;
    public hasDiscount;
    public companyImageName;
    public companyImageText;
    public companyImageData;
    public defaultComment;

    // Sale details
    public details: SaleDetails[];

}

export class SaleDetails {
    public quantity: number;
    public productName;
    public SKU;
    public price: number;
    public subtotal: number;
    public amountDiscount: number;
    public total: number;
    public priceNoDiscount: number;
    public totalNoDiscount: number;
}


// WEBPACK FOOTER //
// ./src/app/models/sale-export-data.ts